import { t } from 'i18next';
import * as yup from 'yup';

import { createNumberInputSchema } from 'core/components/form';

export const tradeSettingsFormSchema = yup
  .object({
    maxOpenPositionsPerDay: createNumberInputSchema({
      min: 1,
      required: true,
      max: Infinity,
      name: t(
        'pages.settings.tradeSettingsForm.fields.maxOpenPositionsPerDay.name'
      ),
    }),
    maxOpenPositions: createNumberInputSchema({
      min: 1,
      required: true,
      max: Infinity,
      name: t('pages.settings.tradeSettingsForm.fields.maxOpenPositions.name'),
    }),
    sessionTradeLimit: createNumberInputSchema({
      min: 1,
      required: true,
      max: Infinity,
      name: t('pages.settings.tradeSettingsForm.fields.sessionTradeLimit.name'),
    }),
  })
  .required();

export type TradeSettingsFormData = yup.InferType<
  typeof tradeSettingsFormSchema
>;
